<script>
    import SelectSearchableMixin from '@components/form/SelectSearchableMixin';
    import LazySelectOptionsMixin from '@components/form/mixins/LazySelectOptionsMixin';
    import {selectDeselectAllOptionValue} from '@components/form/selectSearchableConstants';

    export default {
        mixins: [SelectSearchableMixin, LazySelectOptionsMixin],
        model: {
            prop: 'values',
            event: 'change',
        },
        props: {
            canSelectDeselectAll: {
                type: Boolean,
                default: false,
            },
            closeOnSelect: {
                type: Boolean,
                default: false,
            },
            values: {
                type: Array,
                default: () => [],
            },
        },
        emits: ['change', 'valueChange'],
        data() {
            return {
                selectedOptions: this.getSelectedOptions(this.values),
                allOptionsSelected: false,
            };
        },
        computed: {
            customProps() {
                return {
                    'allow-empty': true,
                    'close-on-select': this.closeOnSelect,
                    'deselect-label': this.$t('form.multiselect.deselect'),
                    multiple: true,
                    value: this.selectedOptions,
                    disabled: this.dependencyDisabled,
                };
            },
        },
        watch: {
            internalOptions() {
                this.loadSelectedOptions(this.values);
                this.updateAllOptionsSelectedFlag();
            },
            values(newValue, oldValue) {
                if (newValue === oldValue) {
                    return;
                }
                this.loadSelectedOptions(newValue);
                this.updateAllOptionsSelectedFlag();
                this.$emit('valueChange');
            },
        },
        methods: {
            getSelectedOptions(values) {
                return this.getFlatOptions(this.baseOptions).filter((option) => {
                    return values.includes(option.value);
                });
            },
            handleInput(selectedOptions) {
                const values = [];

                if (this.canSelectDeselectAll && selectedOptions.find(option => option.value === 'selectDeselectAll')) {
                    // the select/deselect all option was selected
                    if (!this.allOptionsSelected) {
                        this.getFlatOptions(this.options).forEach((option) => {
                            // select all options except for the select/deselect option itself
                            if (option.value !== selectDeselectAllOptionValue) {
                                values.push(option.value)
                            }
                        })
                    } // else: leave values empty
                } else {
                    // regular behavior
                    selectedOptions.forEach((option) => {
                        values.push(option.value)
                    });
                }
                this.$emit('change', values, selectedOptions);
            },
            initializeSelected() {
                this.loadSelectedOptions(this.values);
                this.updateAllOptionsSelectedFlag();
            },
            isOptionSelected(option) {
                return this.values.includes(option.value);
            },
            loadSelectedOptions(values) {
                this.selectedOptions = this.getSelectedOptions(values);
            },
            updateAllOptionsSelectedFlag() {
                // if the amount of selected options is equal to the amount of available options
                // (excluding the select/deselect all option), then all options are selected
                this.allOptionsSelected = (this.getFlatOptions(this.options).length - 1)
                    === this.selectedOptions.length;
            },
        },
    }
</script>
